module.exports = __webpack_public_path__ + "img/favicon-196x196.8bfdb333.png";